import React from 'react'
import notfound from '../Images/notfound.svg'
import { useTranslation } from 'react-i18next'

export default function NotFoundPage() {
  const { t } = useTranslation()

  return (
    <div className='d-flex  justify-content-center w-100' style={{ marginTop: "4rem", marginBottom: "4rem" }}>
      <div className='d-flex flex-column justify-content-between ' style={{ alignItems: "center", width: "35.9rem", height: "32.5", gap: "2rem" }}>
        <img src={notfound} alt="Not Found"
          style={{ width: "25.9375rem", height: "25.8125rem" }}
        />
        <span className='w-100'
          style={{ color: " #292D32", fontFamily: "Cairo", fontSize: "2.75rem", fontWeight: "700", lineHeight: "1.5rem", textAlign: "center" }}
        >{t("not")}</span>
      </div>
    </div>
  )
}
